import createDuck from '../../lib/ducks/remoteDuck'
import Addresses from '../../lib/api/address'

export default createDuck({
  namespace: 'user',
  store: 'addresses',
  fetchCallback: (options) => Addresses.handleOptions(options),
})
